export type Nullable<T> = T | null;
export type Optional<T> = T | undefined;

export type NullableDateRange = {
  from: Date | null;
  to: Date | null;
};

export const defaultNullableDateRange: NullableDateRange = {
  from: null,
  to: null,
};
